export default __webpack_public_path__ + "static/media/A0006.1b185c43.png";